const SliderAuth = () => {

    return (
    <div className="flex flex-col shadow items-center justify-center w-full lg:w-2/5 background-blue rounded-xl shadow-lg text-white p-2">
              <div className="mb-6">
                <img
                  src="/images/logo.png"
                  alt="Icon"
                  className="w-20"
                />
              </div>
              <h2 className="text-lg font-semibold text-center mb-4">
                Lorem ipsum dolor sit amet
              </h2>
              <ul className="text-center space-y-2 mb-6">
                <li>Consectetur adipiscing elit</li>
                <li>Phasellus orci dolor</li>
                <li>Dapibus suscipit quam</li>
              </ul>
              <div className="flex gap-2">
                <span className="w-3 h-3 bg-white rounded-full opacity-50"></span>
                <span className="w-3 h-3 bg-white rounded-full opacity-50"></span>
                <span className="w-3 h-3 bg-white rounded-full opacity-100"></span>
              </div>
            </div>

)
}
export default SliderAuth;